import useClassNames from '@medflex/hooks/useClassNames';
import { useTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import Linkify from 'react-linkify';
import './ChatMessageBubble.css';
import { getFullNameWithLF } from '@medflex/shared-utils';
import MessageReadIndicator from '../MessageReadIndicator';
import { KIND } from '../MessageReadIndicator/MessageReadIndicator';

const ChatMessageBubble = ({
  children,
  className,
  seen,
  seenBy,
  messageSeenText,
  isAudioMessage,
  ...props
}) => {
  const { t } = useTranslation('global', { keyPrefix: 'ChatMessageStream.message' });

  const confirmLeave = React.useCallback(
    e => {
      e.stopPropagation();
      /* eslint-disable-next-line */
      if (!confirm(t('link_confirmation_message'))) {
        // if (!confirm('message bubble')) {
        e.preventDefault();
      }
    },
    [t],
  );

  const cn = useClassNames(
    () => [
      'flex',
      'flex-col',
      'overflow-hidden',
      'p-3',
      'rounded-lg',
      'whitespace-pre-line',
      'max-w-line-length',
      'chatMessageBubble',
      className,
      ...(isAudioMessage ? ['w-full', 'max-w-lg'] : []),
    ],
    [className],
  );

  const wrapperCn = useClassNames(
    () => ['flex', 'mt-1', 'max-w-full', ...(isAudioMessage ? ['w-full', 'max-w-lg'] : [])],
    [isAudioMessage],
  );

  return (
    <div data-component="ChatMessageBubble" className={wrapperCn}>
      <div className={cn} {...props}>
        <Linkify
          className="overflow-hidden"
          properties={{
            onClick: confirmLeave,
            className: 'text-blue-500 hover:underline break-all',
            target: '_blank',
          }}
        >
          {children}
        </Linkify>
        {seenBy?.length > 0 && !seen && (
          <div className="flex justify-end -mr-1">
            <MessageReadIndicator>{seenBy.map(getFullNameWithLF).join('; ')}</MessageReadIndicator>
          </div>
        )}
        {seen && (
          <div className="flex justify-end -mr-1">
            <MessageReadIndicator kind={KIND.PRIMARY}>{messageSeenText}</MessageReadIndicator>
          </div>
        )}
      </div>
    </div>
  );
};

ChatMessageBubble.propTypes = {
  children: PropTypes.node.isRequired,
  seen: PropTypes.bool,
  seenBy: PropTypes.arrayOf(PropTypes.shape),
  messageSeenText: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  isAudioMessage: PropTypes.bool,
};

ChatMessageBubble.defaultProps = {
  seenBy: [],
  seen: false,
  messageSeenText: '',
  className: '',
  isAudioMessage: false,
};

export default ChatMessageBubble;
